import { ISettlementInfoContractForm } from 'services/music-product-digital/types/form';
import { ISettlementInfoContractMutation } from 'services/music-product-digital/types/mutation';
import { IStatisticsQuery } from 'services/statistics/types';
import { IGenre } from 'services/enums/types';
import {
  IArtistWithRoleForm,
  IArtistWithRoleMutation,
  ICopyrights,
  IExternalId,
  IInfinitePageParams,
  IInfinitePageResponse,
  ITitle,
  IWaitingForFile,
  STATUS,
} from 'services/types';

export interface ITrackFilePath {
  wavLink?: string;
  mp3PreviewLink?: string;
  mp3Link?: string;
  flacLink?: string;
  id?: string;
}

export interface ITrackArtistMutation extends IArtistWithRoleMutation {}

export interface ITrackArtistMutationForm extends IArtistWithRoleForm {}

export interface ITrackBase {
  text: string | null;
  isrc: string;
  pline: ICopyrights | null;
  cline: ICopyrights | null;
  language: number;

  isCreatedWithAi: boolean;
  externalIds: IExternalId[];
  // source: TRACK_SOURCE;
  otherTitles: ITitle[];
  mainTitle: ITitle;
}

export interface ITrackMutation extends ITrackBase {
  status: STATUS;
  isInstrumental: boolean;
  artists: ITrackArtistMutation[];
  contractRequests: ISettlementInfoContractMutation[];
  genre: number | null;
  censorious: TRACK_CENSORIOUS | null;
}

export interface ITrackMutationForm
  extends Omit<
      ITrackMutation,
      'artists' | 'contractRequests' | 'genre' | 'censorious'
    >,
    ITrackFilePath {
  file?: File;
  genre: IGenre;
  censorious: TRACK_CENSORIOUS;
  artists: ITrackArtistMutationForm[];
  contracts: ISettlementInfoContractForm[];
  statistics: IStatisticsQuery;
  id: string;
}

export interface ITrackId {
  trackId: string;
}

export interface ICreateTrack extends ITrackMutation, IWaitingForFile {}

export interface IUpdateTrack extends ITrackMutation, ITrackId {}

export interface ITrackArtistResponse extends ITrackArtistMutationForm {
  rolePlacement: number;
}

export interface ITrackResponse extends ITrackBase, ITrackFilePath {
  id: string;
  genre: IGenre | null;
  censorious: TRACK_CENSORIOUS | null;
  trackStatus: STATUS;
  instrumental: boolean;
  artists: ITrackArtistResponse[];
  contracts: ISettlementInfoContractForm[];
}

export interface ITracksResponse extends ITrackResponse {}

export interface ITrackPageResponse
  extends IInfinitePageResponse<ITracksResponse> {}

export interface ITrackFilteredListParams extends IInfinitePageParams {
  title?: string;
  isrc?: string;
  ean?: string;
  artistNickname?: string;
  artistName?: string;
}

export interface ITrackLight {
  id: string;
  mainTitle: string;
}

export interface ITrackContractsTime {
  id: string;
  contracts: ISettlementInfoContractForm[];
}

export interface ITrackFileUploadComplete {
  file: File;
  trackId: string;
}

export enum TRACK_CENSORIOUS {
  unknown = -1,
  explicit = 1,
  notExplicit = 2,
  clean = 3,
}

export enum TRACK_SOURCE {
  unknown = -1,
  local = 1,
  fromDistribution = 2,
}
